export const Loader = () => (
  <div className="flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
    <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
    <span className="ml-2">Loading permissions...</span>
  </div>
);
